import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PayslipService } from 'src/app/services/Dossier/payslip.service';

@Component({
    selector: 'app-single-payslip',
    templateUrl: './single-payslip.component.html',
    styleUrls: ['./single-payslip.component.scss']
})

export class SinglePayslipComponent implements OnInit {

    @Input() isLoading: boolean;
    @Input() anotherIsLoading: boolean;
    @Input() payslip: any;
    @Input() isAnonyme: boolean = false;
    oldPayslipData;
    
    @Output() uploadPayslipEvent = new EventEmitter<any>();
    @Output() removePayslipEvent = new EventEmitter<any>();

    icon: string;
    iconClass: string;
    nameClass: string;
    errorClass : string;
    date: string;
    errorMessage: string = "";

    constructor(
        private payslipService: PayslipService,
    ) { }

    ngOnInit() {
        this.loadParameters();
        if (this.payslip.yearAndMonth || this.payslip.data) {
            this.setDate();
        }
        this.oldPayslipData = this.payslip ? this.payslip.data : null;
        this.setErrors();
    }

    ngOnChanges() {
        this.updateIcon();
    }

    ngDoCheck() {
        if (this.payslip.data !== this.oldPayslipData) {
            this.oldPayslipData = this.payslip.data
            this.loadParameters();
        }
    }

    loadParameters() {
        if (this.payslip.data) {
            this.setDate();
        }
        this.updateIcon();
        this.setErrors();
    }

    updateIcon() {
        if (this.isLoading) {
            this.icon = "assets/image/upload-gif-attente.gif";
            this.iconClass = "loading-icon mt-3";
            this.nameClass = "file-name__loading";
        } else if (this.payslip.data) {
            if (this.payslip.isValid || this.payslip.error) {
                if (this.payslip.otherPages.length > 0) {
                    if (this.isAnonyme) {
                        this.icon = "assets/image/multiple-payslips-icon-anonymized.png";
                    } else {
                        this.icon = "assets/image/multiple-payslips-icon.png";
                    }
                } else {
                    if (this.isAnonyme) {
                        this.icon = "assets/image/payslip-upload-icon-anonymized.png";
                    } else {
                        this.icon = "assets/image/payslip-upload-icon.png";
                    }
                }
                this.iconClass = "shadow";
            } else {
                this.icon = "";
            }
        } else {
            this.icon = "assets/image/illu_upd.svg";
            this.iconClass = "pointer mt-2";
        }
    }
    
    setErrors() {
        if (this.payslip.error) {
            switch (this.payslip.error) {
                case "Ce bulletin n'a pas de période reconnue":
                    this.errorMessage = "Période non identifiée";
                    break;
                case "Oups, la page principale de ce bulletin de salaire semble manquer.":
                    this.errorMessage = "1ère page manquante";
                    break;
                case "Oups, ce document est illisible ou ne correspond pas à un bulletin de salaire.":
                    this.errorMessage = "Document non identifié";
                    this.icon = "";
                    break;
                case "Taille du fichier trop élevée":
                    this.errorMessage = this.payslip.error;
                    this.icon = "";
                    break;
                case "1ère page manquante":
                    this.errorMessage = "1ère page manquante";
                    this.errorClass = "top-33"
                    break;
                case "Erreur de lecture du fichier alto":
                    this.errorMessage = "Erreur de lecture du fichier alto";
                    this.errorClass = "top-33"
                    break;
                case "Le modèle de BS est inconnu":
                    this.errorMessage = "Le modèle de BS est inconnu";
                    this.errorClass = "top-33"
                    break;
                case "Le document comporte beaucoup trop d'erreurs":
                    this.errorMessage = "Le document comporte beaucoup trop d'erreurs";
                    this.errorClass = "top-33"
                    break;
                default : 
                    this.errorMessage = "Erreur d'identification";
                    this.icon = "";
            }
        }
    }

    uploadPayslip() {
        if (!this.payslip.data && !this.anotherIsLoading) {
            this.uploadPayslipEvent.emit(this.payslip.yearAndMonth);
        }
    }

    removePayslip() {
        let data = [];
        data.push(this.payslip.data);
        this.payslip.otherPages.forEach(page => {
            data.push(page);
        });
        this.payslipService.removePayslip(data).subscribe((result) => {
            if (result) {
                this.removePayslipEvent.emit(this.payslip);
            }
        })
    }
    
    showPayslip() {
        let data = [];
        data.push(this.payslip.data);
        this.payslip.otherPages.forEach(page => {
            if (page.url || page.urlfront) {
                data.push(page);
            }
        });
        this.payslipService.showPayslip(data);
    }

    setDate() {
        let startDate = null;
        if (this.payslip && this.payslip.isValid) {
            startDate = new Date(this.payslip.data["datedebutbs"]);
        } else if (this.payslip.yearAndMonth) {
            let year = this.payslip.yearAndMonth.toString().substring(0, 4);
            let month = this.payslip.yearAndMonth.toString().substring(4, 6);
            startDate = new Date(year, month);
        }

        if (startDate) {
            this.date = startDate.toLocaleString("fr", {month : "long"}) 
                + " " + startDate.toLocaleString("fr", {year : "numeric"});
        }
    }
}
